import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Drawer, Box } from '@mui/material';
import { RootState, AppDispatch } from '../../Redux/store';
import { updateOpen } from '../../Redux/Slices/Policy/policy';
import DrawerHeading from '../../components/Drawer/drawerHeading';
import CommonAddPolicy from './CommonAddPolicy';

export default function AddNewPolicy() {
  const dispatch = useDispatch<AppDispatch>();
  const { open } = useSelector((state: RootState) => state.policySettings);
  const styles = {
    parentBox: { height: 'auto' },
    height: {
      xxl: '67vh !important',
      xl: '65vh !important',
      lg: '50vh !important',
      md: '60vh !important',
    },
  };
  return (
    <Drawer
      open={open}
      onClose={() => dispatch(updateOpen(false))}
      anchor="right"
    >
      <Box
        sx={{
          width: {
            xxl: '60rem !important',
            xl: '55rem !important',
            lg: '45rem !important',
            md: '40rem !important',
          },
          height: {
            xxl: '120rem !important',
            xl: '100rem !important',
            lg: '40rem !important',
            md: '40rem !important',
          },
        }}
        p={{ xl: '1rem', lg: '1rem', md: '0.5rem' }}
      >
        <DrawerHeading
          title="Policy Settings"
          subtitle="Configure Policy for your application here."
          onClose={() => dispatch(updateOpen(false))}
        />
        <CommonAddPolicy page="new" styles={styles} />
      </Box>
    </Drawer>
  );
}
